import { FC } from 'react'

import styled from 'styled-components'
import { Modal } from 'antd'

import { useGetAdVisualVideoByIdQuery } from 'src/Redux/adsCampaignApi'
import { variables } from 'src/Styled/variables'

interface AdVisualPerformanceVideoPopupProps {
  adVisualId: string
  campaignId: string
  name: string
  onClose: () => void
}

const StyledModal = styled(Modal)`
  width: 348px !important;
  min-width: 288px;
  max-width: 400px;

  .ant-modal-content {
    padding: 0;
    border-radius: 16px;
    border: 1px solid ${({ theme }) => theme.color.lightGrey};
    background-color: ${({ theme }) => theme.color.white};
    box-shadow: ${({ theme }) => theme.shadow.card};
    overflow: hidden;
    height: 648px;
    display: flex;
    flex-direction: column;
  }

  .ant-modal-header {
    display: none;
  }

  .ant-modal-body {
    flex: 1;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    min-height: 0;
  }
  .ant-modal-close-icon {
    svg {
      path {
        fill: ${({ theme }) => theme.color.darkGrey};
      }
    }
  }
`

const Header = styled.div`
  padding: 16px 24px;
  display: flex;
  align-items: center;
  flex-shrink: 0;
  border-bottom: 1px solid ${({ theme }) => theme.color.lightGrey};
`

const VideoName = styled.span`
  font-family: 'Segoe UI', sans-serif;
  font-size: ${variables.fontSize18};
  font-weight: ${variables.fontWeight600};
  line-height: 150%;
  color: ${({ theme }) => theme.color.darkGrey};
`

const VideoPlayerWrapper = styled.div`
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  padding: 24px;
`

const VideoPlayer = styled.video`
  width: 100%;
  height: 100%;
  display: block;
  object-fit: cover;
  border-radius: 8px;
`

const VideoStateWrapper = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
`

const StateMessage = styled.span`
  font-family: 'Segoe UI', sans-serif;
  font-size: ${variables.fontSize14};
  font-weight: ${variables.fontWeight400};
  line-height: 150%;
  color: ${({ theme }) => theme.color.slateGrey};
  text-align: center;
`

export const AdVisualPerformanceVideoPopup: FC<
  AdVisualPerformanceVideoPopupProps
> = ({ adVisualId, campaignId, name, onClose }) => {
  const { data, isLoading, isError } = useGetAdVisualVideoByIdQuery({
    campaignId,
    adVisualId,
  })

  return (
    <StyledModal open title={null} footer={null} centered onCancel={onClose}>
      <Header>
        <VideoName>{name}</VideoName>
      </Header>
      <VideoPlayerWrapper>
        {isLoading && (
          <VideoStateWrapper>
            <StateMessage>Loading video…</StateMessage>
          </VideoStateWrapper>
        )}
        {isError && (
          <VideoStateWrapper>
            <StateMessage>Video is not available</StateMessage>
          </VideoStateWrapper>
        )}
        {data?.videoUrl && (
          <VideoPlayer src={data.videoUrl} controls autoPlay muted />
        )}
      </VideoPlayerWrapper>
    </StyledModal>
  )
}
